import { transition } from '@helpers/animate';
import brand, { ThemeOption } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { h4, paragraphSmall } from '@helpers/typography';
import { rgba } from 'polished';
import styled from 'styled-components';
import { CtaCardStyles } from '../CtaCard/CtaCard.styles';
import { InformationCardStyles } from '../InformationCard/InformationCard.styles';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 6px ${rgba(brand.black, 0.16)};
  color: inherit;
  text-decoration: none;

  &[data-featured] {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 30px;
    box-shadow: none;

    @media ${until(Device.TabletSmall)} {
      display: none;
    }
  }

  &[data-component-theme=${ThemeOption.Orange}] {
    --themeColor: ${brand.orange};
  }

  &[data-component-theme=${ThemeOption.Blue}] {
    --themeColor: ${brand.blue};
  }

  &[data-component-theme=${ThemeOption.Purple}] {
    --themeColor: ${brand.purple};
  }

  &[data-component-theme=${ThemeOption.Red}] {
    --themeColor: ${brand.red};
  }

  &[data-component-theme=${ThemeOption.Green}] {
    --themeColor: ${brand.green.default};
  }

  &[data-component-theme=${ThemeOption.DarkGreen}] {
    --themeColor: ${brand.green.dark};
  }

  &[data-component-theme=${ThemeOption.Teal}] {
    --themeColor: ${brand.teal};
  }
`;
const ImageWrapper = styled.div `
  position: relative;
  aspect-ratio: 46 / 35;
  overflow: hidden;

  ${Container}[data-featured] & {
    aspect-ratio: auto;
  }

  &::before {
    content: '';
    position: absolute;
    top: 25px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${brand.white};
    z-index: 1;
    pointer-events: none;
  }
`;
const CategoryTag = styled.span `
  position: absolute;
  top: 8px;
  left: 0;
  padding: 9px 12px 7px;
  ${fonts.agBook.bold};
  font-size: 14px;
  line-height: 18px;
  color: ${brand.white};
  text-transform: uppercase;
  background-color: var(--themeColor);
  z-index: 1;
`;
const Image = styled.img `
  max-width: none;
  width: 100%;
  height: auto;
  ${transition('transform')};
  will-change: transform, contents !important;
  transform-origin: 50% 50%;

  ${Container}:is(a):hover & {
    transform: scale(1.1);
  }

  ${Container}[data-featured] & {
    height: 100%;
    object-fit: cover;
  }
`;
const CardContent = styled(InformationCardStyles.Content) `
  ${Container}[data-featured] & {
    background-color: var(--themeColor);
    padding: 20px 30px;
  }
`;
const NewsCardContent = styled(CardContent) `
  position: relative;
  padding-bottom: 76px;
`;
const Title = styled.h4 `
  ${h4};
  margin-bottom: 12px;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  ${Container}:is(a):hover & {
    text-decoration: underline;
  }

  ${Container}[data-featured] & {
    font-size: 32px;
    line-height: 38px;
    color: ${brand.white};
  }
`;
const Content = styled.p `
  ${paragraphSmall};
  margin-bottom: 10px;

  ${Container}[data-featured] & {
    color: ${brand.white};
  }
`;
const ArticleInfo = styled.div ``;
const ArticleInfoItem = styled.div `
  display: flex;
  align-items: center;
  margin-top: 8px;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  color: var(--themeColor);

  ${Container}[data-featured] & {
    color: ${brand.white};
  }
`;
const ArticleInfoItemIcon = styled.div `
  display: flex;
  align-items: center;
  width: 17px;
  margin-right: 7px;
`;
const ArrowIcon = styled(CtaCardStyles.ArrowIcon) `
  top: auto;
  bottom: 20px;
  right: 20px;

  @media ${from(Device.MobileLarge)} {
    top: auto;
    bottom: 20px;

    ${Container}[data-featured] & {
      right: 30px;
    }
  }

  ${Container}[data-featured] & {
    background-color: ${brand.white};

    svg {
      path:first-child {
        stroke: var(--themeColor);
      }
    }
  }
`;
export const ArticleCardStyles = {
    ArrowIcon,
    CardContent,
    CategoryTag,
    Container,
    Content,
    ArticleInfo,
    ArticleInfoItem,
    ArticleInfoItemIcon,
    Image,
    ImageWrapper,
    NewsCardContent,
    Title,
};
